import type { ModuloWeb } from '../../nucleo/modulos-web';
import { BotaoCriarTarefa } from './CriarDoRegistro';
import { i18n } from './i18n';
import { Lista } from './Lista';
import { Marcos } from './Marcos';
import { Minhas } from './Minhas';
import { Painel } from './Painel';
import { QuadroKanban } from './QuadroKanban';
import { Projetos } from './Projetos';
import { Quadros } from './Quadros';
import { buscaTarefas } from './busca-global';

/** Fase 2, W10: módulo Tarefas no menu Operação (catálogo: "Projetos e tarefas"). */
const modulo: ModuloWeb = {
  slug: 'tarefas',
  menu: 'operacao',
  ordem: 30,
  abas: [
    { chave: 'kanban', permissao: 'tarefas.ver', componente: QuadroKanban },
    { chave: 'lista', permissao: 'tarefas.ver', componente: Lista },
    { chave: 'minhas', permissao: 'tarefas.ver', componente: Minhas },
    { chave: 'painel', permissao: 'tarefas.ver', componente: Painel },
    { chave: 'quadros', permissao: 'tarefas.ver', componente: Quadros },
    // Pacote 2 (onda 1a): Projetos e tarefas (o projeto é um quadro ligado a um projeto do Cadastros) e os marcos.
    { chave: 'projetos', permissao: 'tarefas.ver', componente: Projetos },
    { chave: 'marcos', permissao: 'tarefas.ver', componente: Marcos },
  ],
  i18n,
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaTarefas,
  // Fase 2 (W23, K11): "Criar tarefa" no chatter de qualquer registro.
  acaoNoRegistro: BotaoCriarTarefa,
};

export default modulo;
